import * as React from 'react';
import styles from './image.scss';

interface ObjectFitPolyfillProps{
  src: string;
  alt?: string;
  className?: string;
  cover?: boolean;
  [prop: string]: any;
}

const supportObjectFit = 'objectFit' in document.documentElement.style === true;

const propToStyle = (target, source, propName) => {
  if(source[propName]) {
    if(String(source[propName]).indexOf('%') !== -1) {
      target[propName] = source[propName];
    } else {
      target[propName] = source[propName] + 'px';
    }
  }
};

export const ObjectFitImage = ({src, alt, className, cover, ...rest}:ObjectFitPolyfillProps) => {
  const sizingStyle = cover ? styles.cover : styles.contain;
  const styleClassName = `image ${sizingStyle} ${className}`;

  if (supportObjectFit) {
    return <img src={src} alt={alt} className={styleClassName} {...rest} />;
  }

  const containerSize = {backgroundImage: `url(${src})`};
  propToStyle(containerSize, rest, 'width');
  propToStyle(containerSize, rest, 'height');

  return <div id={rest.id} role="image" aria-label={alt}
    className={`${styles.fallback} ${styleClassName} `} style={containerSize}/>;

};
